import { render, staticRenderFns } from "./productPicker.vue?vue&type=template&id=0a9fee58&scoped=true"
import script from "./productPicker.vue?vue&type=script&lang=js"
export * from "./productPicker.vue?vue&type=script&lang=js"
import style0 from "./productPicker.vue?vue&type=style&index=0&id=0a9fee58&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9fee58",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/dvl/tthomsen/compiere-all/pharmanord2011/template/webapps/buybuttoncompact/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a9fee58')) {
      api.createRecord('0a9fee58', component.options)
    } else {
      api.reload('0a9fee58', component.options)
    }
    module.hot.accept("./productPicker.vue?vue&type=template&id=0a9fee58&scoped=true", function () {
      api.rerender('0a9fee58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/productPicker.vue"
export default component.exports